import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-info-hero__content" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--d2 gfu-hd--decorative _tc--accent-inverse _mb-4" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-info-hero _jc-c', $options.rootClasses])
  }, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gfu-info-hero__cover" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createElementVNode("h2", _hoisted_2, _toDisplayString($props.title), 1 /* TEXT */)
      ]),
      _renderSlot(_ctx.$slots, "description", {}, () => [
        _createTextVNode(_toDisplayString($props.description), 1 /* TEXT */)
      ])
    ])
  ], 2 /* CLASS */))
}